import { render } from "./Home.vue?vue&type=template&id=67db66d6&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=67db66d6&lang=scss&scoped=true"

import exportComponent from "/data/heYou-h5/panther-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67db66d6"]])

export default __exports__